<div class="content">
    <h2>Erzeugungsanlagen</h2>
    <redispatch-erzeugungsanlage-list></redispatch-erzeugungsanlage-list>
</div>

